import { render, staticRenderFns } from "./BaseWidgetForm.vue?vue&type=template&id=0405e1fa&"
import script from "./BaseWidgetForm.vue?vue&type=script&lang=js&"
export * from "./BaseWidgetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports